import * as R from 'ramda';
import axios from 'axios';
import { XbpmErrorType, XBPM_CANCELATION, XBPM_ERROR_KIND, } from '../../models/common.types';
export var cancelation = function () {
    var _a;
    return (_a = {}, _a[XBPM_CANCELATION] = true, _a);
};
export var isCancelation = function (err) { return !!err && err[XBPM_CANCELATION] === true; };
// errors
var UNKNOWN_ERROR_MSG = 'Unknown error';
export var UNKNOWN_ERROR_CODE = 'UNKNOWN_ERROR';
export var CONNECTION_ERROR_CODE = 'CONNECTION_ERROR';
// http error
export var mapHttpError = R.curry(function (description, error) {
    var _a;
    var _b = error.response || { status: 0, data: null }, status = _b.status, _data = _b.data;
    // fix: for response data as string
    var data = _data;
    if (typeof data === 'string') {
        try {
            data = JSON.parse(data);
        }
        catch (_c) {
            data = { formUnavailable: true };
        }
    }
    //
    var code = R.path(['code'], data) || error.code || (!status ? CONNECTION_ERROR_CODE : UNKNOWN_ERROR_CODE);
    var type = R.path(['type'], data) || XbpmErrorType.SYSTEM;
    var message = R.path(['message'], data) || error.message || UNKNOWN_ERROR_MSG;
    var stackTrace = R.path(['stackTrace'], data) || error.stack || null;
    var formUnavailable = R.path(['formUnavailable'], data) || false;
    return _a = {},
        _a[XBPM_ERROR_KIND] = 'http',
        _a.status = status,
        _a.code = code,
        _a.type = type,
        _a.message = message,
        _a.description = description,
        _a.stackTrace = stackTrace,
        _a.formUnavailable = formUnavailable,
        _a[XBPM_CANCELATION] = axios.isCancel(error),
        _a;
});
export var throwHttpError = R.curry(function (description, error) {
    throw mapHttpError(description, error);
});
export var isHttpError = function (err) { return !!err && err[XBPM_ERROR_KIND] === 'http'; };
// internal error
var mapError = function (error) {
    if (error instanceof Error) {
        return error;
    }
    var message = UNKNOWN_ERROR_MSG;
    try {
        message = typeof error === 'string' ? error : JSON.stringify(error);
    }
    catch (_a) {
        // unknown error
    }
    finally {
        error = new Error(message);
        error.name = UNKNOWN_ERROR_CODE;
        error.stack = null;
    }
    return error;
};
export var mapInternalError = function (error, description) {
    var _a;
    if (description === void 0) { description = null; }
    var err = mapError(error);
    var code = err.name || UNKNOWN_ERROR_CODE;
    var type = XbpmErrorType.SYSTEM;
    var message = err.message;
    var stackTrace = err.stack || null;
    return _a = {}, _a[XBPM_ERROR_KIND] = 'internal', _a.code = code, _a.type = type, _a.message = message, _a.description = description, _a.stackTrace = stackTrace, _a;
};
export var throwInternalError = function (error, description) {
    throw mapInternalError(error, description);
};
export var isInternalError = function (err) { return !!err && err[XBPM_ERROR_KIND] === 'internal'; };
//# sourceMappingURL=result.utils.js.map